import React from 'react';
import { observer } from 'mobx-react';
import { Link } from 'react-router-dom';
import { Breadcrumb, BreadcrumbItem } from 'reactstrap';
import { mdiChevronLeft } from '@mdi/js';
import Icon from '@mdi/react';
import './BreadcrumbsControlled.scss';

// Example: crumbs={[
//   { description: 'Back', url: '/admin/error-messages' },
//   { description: messageId ? `Edit Error - ${vm.message.errorCode}` : 'Add New Error' },
// ]}

export const BreadcrumbsControlled = observer(({ crumbs }) => {
  return (
    <Breadcrumb listTag="ul" tag="nav" className="breadcrumbs-controlled">
      {crumbs.map((el, i: number) => {
        return (
          <BreadcrumbItem key={`breadcrumb-item-${i}`}>
            {el.url ? (
              <Link to={el.url}>
                {i === 0 ? <Icon path={mdiChevronLeft} size={1} /> : null}
                {el.description}
              </Link>
            ) : (
              el.description
            )}
          </BreadcrumbItem>
        );
      })}
    </Breadcrumb>
  );
});
